module.exports = __webpack_public_path__ + "img/multiple-stakeholders-deal.36cf5f68.svg";